import { FC } from "react";
import { StyledIframe, Wrapper, Caption } from "./Youtube.styled";
import parse from "html-react-parser";

interface Props {
  data: { id?: string; localCaption?: string };
}

const Youtube: FC<Props> = ({ data }) => {
  if (!data) {
    return null;
  }
  return (
    <>
      <Wrapper>
        <StyledIframe
          src={`https://www.youtube.com/embed/${data.id}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      </Wrapper>
      <Caption>{data.localCaption && parse(data.localCaption)}</Caption>
    </>
  );
};

export default Youtube;
